import * as Types from "../constants/User";
import { ViewState } from "redux/constants/App";
import { setBusy, setError, setReady } from "./utils";

const initialState = {
  users: [],
  error: {
    status: null,
    message: null,
    errors: [],
  },
  profile: {
    fullName: null,
    company: {
      id: null,
      name: null,
    },
    client: {
      id: null,
      name: null,
    },
    userType: "",
  },
  user: {
    id: null,
    firstname: null,
    lastname: null,
    email: null,
    mobile: null,
    roleId: null,
    companyId: null,
  },
  profileStatus: ViewState.IDLE,
};

const actions = {
  [Types.FETCH_PROFILE]: (state) =>
    setBusy({ state, statusKey: "profileStatus" }),
  [Types.FETCH_PROFILE_FAILED]: (state, err) =>
    setError({ state, statusKey: "profileStatus", error: err }),
  [Types.FETCH_PROFILE_OK]: (state, profile) =>
    setReady({ state, statusKey: "profileStatus", payload: { profile } }),
};

export default function (state = initialState, { type: actionType, payload }) {
  const action = actions[actionType];
  if (action) return action(state, payload);
  return state;
}
